module.exports = __webpack_public_path__ + "img/2.335f7fff.png";